export default async (app) => {
  // TODO: Migrate to server side to allow removing new httpOnly cookies for access- & refresh tokens.
  try {
    // Names must match the server-side setters in api/index.js — previously
    // these were snake_case here and camelCase there, so logout never cleared
    // the real auth cookies.
    await app.$cookies.remove("accessToken");
    await app.$cookies.remove("refreshToken");
    await app.$cookies.remove("idToken");
    await app.$cookies.remove("pastUrl");
  } catch (e) { /* cookies may not be available during SSR error recovery */ }

  if (app.$store) {
    try {
      await app.$store.dispatch("Auth/logout");
      await app.$store.commit("Workspace/reset");
      app.$store.commit("Auth/setData", { data: false, label: "isAuthorize" });
    } catch (e) { /* store may not be fully initialised during SSR */ }

    if (app.$store.$churnZero) {
      try { app.$store.$churnZero.stop(); } catch (e) { /* ignore */ }
    }
  }

  if (app.$axios) {
    app.$axios.setHeader("Authorization", "");
  }
};
